import React, { useState } from 'react';
import { PageTitle } from '@cordata/buffet';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FileSelectModal from '~/components/common/JsonFileSelect';

import Form from '~/components/ConfiguredReport/Form';

const ConfiguredReportsAdd = () => {
  const [data, setData] = useState({});
  const [fileSelectModalIsOpen, setFileSelectModalIsOpen] = useState(false);

  const importData = () => {
    setFileSelectModalIsOpen(true);
  };

  return (
    <>
      <PageTitle
        action={
          <Button onClick={() => importData()}>
            <FontAwesomeIcon icon="file-import" />
            <span className="d-none d-md-inline ml-2">Import</span>
          </Button>
        }
      >
        Add Configured Report
      </PageTitle>

      <Form data={data} />

      <FileSelectModal
        isOpen={fileSelectModalIsOpen}
        setIsOpen={setFileSelectModalIsOpen}
        setData={setData}
      />
    </>
  );
};

export default ConfiguredReportsAdd;
